module.exports = __webpack_public_path__ + "img/40.0c1d4e57.jpg";